import { Component, inject } from '@angular/core';

import { CdkMenuModule } from '@angular/cdk/menu';

import { environment } from '../../../../environments/environment';
import { authCodeFlowConfig } from '../../../config/identity-server.config';

import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'account-settings',
  imports: [CdkMenuModule],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.scss',
})
export class AccountSettingsComponent {
  abr: string = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  profileImg: string = '';
  identifier: string = '';

  private authService = inject(AuthService);

  ngOnInit(): void {
    this.email = this.authService.getEmail();
    this.firstName = this.authService.getFirstName();
    this.lastName = this.authService.getLastName();
    this.abr = this.firstName.charAt(0).toUpperCase() + this.lastName.charAt(0).toUpperCase();
    this.profileImg = this.authService.getProfileImg();
    this.identifier = this.authService.getIdentifier();
  }

  public navigateToSettings(): void {
    const { clientId } = authCodeFlowConfig;
    const isSettingsUrl = new URL(environment.isUserSettings);
    let urlSearchParams = new URLSearchParams();

    if (!clientId || !authCodeFlowConfig.redirectUri) {
      throw new Error('Missing auth config values');
    }

    isSettingsUrl.search = urlSearchParams.toString();

    window.open(isSettingsUrl.href.toString(), '_blank');
  }

  public onLogout(): void {
    this.authService.logout();
  }
}
